import { Field } from '#/components/Form/Field/Field';
import { RadioButtons } from '#/components/Radio/RadioButtons';

type Props = {
  qaId?: string;
  id?: string;
  name: string;
  label?: string;
  description?: string;
  disabled?: boolean;
  options: { value: string }[];
};

export function RequestedSingleOptionField({
  id,
  name,
  label,
  description,
  disabled,
  qaId,
  options,
}: Props) {
  const subName = `${name}.option_single`;

  return (
    <Field
      name={name}
      label={label}
      description={description}
      customErrorMatch={(errors) => errors[name] ?? errors[subName]}
      renderInput={({ qaId: fieldQaId, value, updateValue }) => (
        <RadioButtons
          qaId={qaId ?? fieldQaId}
          id={id}
          disabled={disabled}
          // TODO: Fix this the next time the file is edited.
          // oxlint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          value={value?.option}
          buttons={options.map((o) => ({ ...o, label: o.value }))}
          onChange={(v) => {
            updateValue(
              v
                ? {
                    type: 'OPTION_SINGLE',
                    option: v,
                  }
                : null,
            );
          }}
        />
      )}
    />
  );
}
